class CustomError extends Error {
  constructor(code, message) {
    // const fullMsg = message ? `${code}: ${message}` : code;
    const fullMsg = message || code;
    super(fullMsg);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }

    this.code = code;
    this.message = fullMsg;
    this.name = 'Error';
  }

  toString() {
    return this.message;
  }
}

export default CustomError;
